import { cn } from "@/utils/cn";

interface PlanMethodologyNoteProps {
  className?: string;
  showRecommendationsNote?: boolean;
}

export const PlanMethodologyNote = ({
  className,
  showRecommendationsNote = true,
}: PlanMethodologyNoteProps) => {
  return (
    <div
      className={cn(
        "text-xs text-gray-600 bg-gray-50 border border-gray-200 rounded-lg p-3 space-y-2",
        className,
      )}
    >
      <div className="space-y-1">
        <p className="font-semibold text-gray-800">
          How does NutriCoach calculate plan macros and calories?
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            Daily energy expenditure is based on the{" "}
            <a
              href="https://reference.medscape.com/calculator/846/mifflin-st-jeor-equation"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Mifflin-St Jeor Equation
            </a>
            .
          </li>
          <li>
            Macronutrients follow guidance from{" "}
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/16004827/"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Exercise and the Institute of Medicine recommendations for
              nutrition
            </a>
            .
          </li>
        </ul>
      </div>

      {showRecommendationsNote && (
        <p className="text-gray-700">
          Meal recommendations and swaps keep weekly calories and macros within
          approximately ±10% of your targets derived from the above sources.
        </p>
      )}
    </div>
  );
};
